export default __webpack_public_path__ + "static/media/texture1.3fce5672.png";